export enum PresetColors {
  VIOLET = 'PRIMARY_VIOLET',
  AQUA = 'PRIMARY_AQUA',
  TEAL = 'PRIMARY_TEAL',
  GREEN = 'SEMANTIC_SUCCESS',
  YELLOW = 'PRIMARY_YELLOW',
  ORANGE = 'SEMANTIC_WARNING',
  RED = 'SEMANTIC_ERROR',
  PINK = 'PRIMARY_PINK',
  PURPLE = 'PRIMARY_PURPLE'
}
